module.exports = __webpack_public_path__ + "static/media/tech-structured-4.64f10358.png";